import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    home: [],
    movies: [],
    shows: [],
    searches: [],
};

const ReduxSlice = createSlice({
    name: 'movieStie',
    initialState,
    reducers: {
        fetchMovies(state, action) {
            return { ...state, movies: action.payload };
        },

        fetchShows(state, action) {
            return { ...state, shows: action.payload };
        },

        fetchBoth(state, action) {
            return { ...state, home: action.payload };
        },

        fetchQuery(state, action) {
            return { ...state, searches: action.payload };
        },
    },
});

export const { fetchMovies, fetchShows, fetchBoth, fetchQuery } = ReduxSlice.actions;

export default ReduxSlice.reducer;


// export const fetchReducer = (state = initialState, action) => {
//     switch (action.type) {
//         case "FETCH_MOVIES":
//             // return state;
//             return { ...state, movies: action.payload };

//         case "FETCH_SHOWS":
//             return { ...state, shows: action.payload };

//         case "FETCH_BOTH":
//             return { ...state, home: action.payload };
            

//         case "SEARCH_QUERY":
//             return { ...state, searches: action.payload };

//         default:
//             return state;
//     }
// }
